// Phone UI Tab Constants

// Main Tabs
export const MAIN_TABS = {
  CALLS: "calls",
  MESSAGES: "messages",
  SETTINGS: "settings",
};

// Phone Sub-Tabs (under CALLS)
export const PHONE_TABS = {
  DIALPAD: "dialpad",
  LOGS: "logs",
  QUEUE: "queue",
  ANALYTICS: "analytics",
};

// Messages Sub-Tabs (under MESSAGES)
export const MESSAGES_TABS = {
  NEW: "new",
  CONVERSATIONS: "conversations",
};

// Mirrors backend app.constants.ConversationChannel. `enabled: false` channels
// render as a disabled affordance to preview future expansion.
export const CONVERSATION_CHANNELS = [
  { value: "sms", label: "SMS", enabled: true },
  { value: "email", label: "Email", enabled: true },
];

// Settings Sub-Tabs (under SETTINGS)
export const SETTINGS_TABS = {
  AUDIO: "audio",
  TEST: "test",
  VOICEMAIL: "voicemail",
};

// Tab Items for Ant Design Tabs component
export const PHONE_TAB_ITEMS = [
  { key: PHONE_TABS.DIALPAD, label: "Dialpad" },
  { key: PHONE_TABS.LOGS, label: "Logs" },
  { key: PHONE_TABS.QUEUE, label: "Queue" },
  { key: PHONE_TABS.ANALYTICS, label: "Analytics" },
];

export const MESSAGES_TAB_ITEMS = [
  { key: MESSAGES_TABS.NEW, label: "New" },
  { key: MESSAGES_TABS.CONVERSATIONS, label: "Conversations" },
];

export const SETTINGS_TAB_ITEMS = [
  { key: SETTINGS_TABS.AUDIO, label: "Audio" },
  { key: SETTINGS_TABS.TEST, label: "Audio Test" },
  { key: SETTINGS_TABS.VOICEMAIL, label: "Voicemail" },
];
